import { useHomeText } from '../text';

const Trust = () => {
  const t = useHomeText();
  return (
    <section id="trust" style={{ maxWidth: "1280px", margin: "0 auto", padding: "112px 24px", display: "flex", flexDirection: "column", gap: "40px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", textAlign: "center" }}>
        <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
          {t.trust.testimonials}
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
          {t.trust.whatDoTeachersSay}
        </h2>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(360px, 100%), 1fr))", gap: "20px" }}>
        <figure style={{ margin: "0", background: "#141C63", color: "#FFFFFF", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px", gridColumn: "span 1" }}>
          <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#FFC93C" }}>
            ”
          </span>
          <blockquote style={{ margin: "0", fontSize: "18px", lineHeight: "1.9" }}>
            {t.trust.inTheAgeOf}
          </blockquote>
          <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
            <strong>
              {t.trust.habibaRais}
            </strong>
            <span style={{ fontSize: "14px", color: "#C9CEF5" }}>
              {t.trust.arabicTeacherForBeginners}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
          <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
            ”
          </span>
          <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
            {t.trust.funAndLearningOn}
          </blockquote>
          <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
            <strong>
              {t.trust.ayaEnnaoui}
            </strong>
            <span style={{ fontSize: "14px", color: "#4B5480" }}>
              {t.trust.primarySchoolTeacher}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
          <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
            ”
          </span>
          <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
            {t.trust.aSolidStepThat}
          </blockquote>
          <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
            <strong>
              {t.trust.najmeddineJarfel}
            </strong>
            <span style={{ fontSize: "14px", color: "#4B5480" }}>
              {t.trust.retiredSeniorPrimarySchool}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
          <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#46D3BE" }}>
            ”
          </span>
          <blockquote style={{ margin: "0", fontSize: "17px", lineHeight: "1.9", color: "#2A3160" }}>
            {t.trust.modernInnovativeLearningCapsules}
          </blockquote>
          <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto" }}>
            <strong>
              {t.trust.mohamedZiraoui}
            </strong>
            <span style={{ fontSize: "14px", color: "rgb(75, 84, 128)" }}>
              {t.trust.civicEducationTeacher}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFC93C", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "18px" }}>
          <span aria-hidden="true" style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "72px", lineHeight: "0.6", color: "#0B1240" }}>
            ”
          </span>
          <blockquote style={{ margin: "0", fontSize: "20px", lineHeight: "1.8", fontWeight: "600", color: "#0B1240" }}>
            {t.trust.everyBeginningStartsWith}
          </blockquote>
          <figcaption style={{ display: "flex", flexDirection: "column", marginTop: "auto", color: "#0B1240" }}>
            <strong>
              {t.trust.salmaHabibi}
            </strong>
            <span style={{ fontSize: "14px" }}>
              {t.trust.seniorPrimarySchoolTeacher}
            </span>
          </figcaption>
        </figure>
        <div style={{ background: "#E2F7F3", borderRadius: "28px", padding: "32px", display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "flex-start" }}>
          <span dir="ltr" style={{ fontFamily: "\"Baloo Bhaijaan 2\", sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "rgb(20, 94, 85)" }}>
            +2000
          </span>
          <span style={{ fontSize: "17px", color: "rgb(46, 74, 71)" }}>
            {t.trust.parentsHaveDownloadedKhotoua}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Trust;
